import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import '../../assets/styles/DashboardStyling.css';
import ReactApexChart from 'react-apexcharts';
import { Spin } from 'antd';
import { useRecoilValue } from 'recoil';
import { iconsData } from '../../../../../service/memory/recoil/theme';

const MainTrendChart = ({ loading, mainTrendData, targetHoursSet }) => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const icons = useRecoilValue(iconsData);

    const [targetHours, setTargetHours] = useState(targetHoursSet);

    const data = mainTrendData?.filter(item => item.current_date)

    const series = [
        {
            name: "Current Hours",
            data:
                data && data.length ?
                    data.map((item) => {
                        const timestamp = new Date(item.current_date).getTime();
                        return {
                            x: timestamp,
                            y: item.current_hours,
                        };
                    }) : [],
        },
        {
            name: "Target Hours",
            data:
                data && data.length ?
                    data.map((item) => {
                        const timestamp = new Date(item.current_date).getTime();
                        return {
                            x: timestamp,
                            y: targetHours,
                        };
                    }) : [],
        },
        {
            name: "Previous Hours",
            data:
                data && data.length ?
                    data.map((item) => {
                        const timestamp = new Date(item.current_date).getTime();
                        return {
                            x: timestamp,
                            y: item.previous_hours,
                        };
                    }) : [],
        },
    ];

    useEffect(() => {
        setTargetHours(targetHoursSet);
    }, [targetHoursSet]);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 769);
        };
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const options = {
        chart: {
            type: 'line',
            toolbar: {
                offsetX: isSmallScreen ? -22 : -75,
                offsetY: -13,
                tools: {
                    download: `<button class="download-btn-icon"><img src="${icons.download}"> <span>Download</span></button>`,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false
                }
            }
        },
        xaxis: {
            type: "datetime",
            title: {
                text: "Days"
            }
        },
        yaxis: {
            labels: {
                formatter: function (value) {
                    return Math.floor(value);
                }
            },
            title: {
                text: "Number of Hours"
            },
            tickAmount: 4,
        },
        stroke: {
            width: 2,
        },
        tooltip: {
            shared: true,
            intersect: false
        },
        legend:{
            offsetY: 8,
        }
    };

    return (
        <div className='col-12 col-md-6 col-lg-6 col-xl-6 mb-4'>
            <Card style={{ padding: "1rem" }} className='listCardStylingSecondRow'>
                <Card.Title className='volunteersPerformanceCardTitle'>
                    Targets
                </Card.Title>
                {loading && <Spin size="medium" className="d-flex justify-content-center m-auto" />}
                {!loading &&
                    <>
                        <hr style={{ marginBlock: '6px', opacity: '0.15' }} />
                        <div className='chartContainerStyling'>
                            <ReactApexChart
                                options={options}
                                series={series}
                                type="line"
                                height={192}
                            />
                        </div>
                    </>}
            </Card>
        </div>
    )
}

export default MainTrendChart

